import { render } from "./PaginationPage.vue?vue&type=template&id=a1ed8fca&scoped=true"
import script from "./PaginationPage.vue?vue&type=script&lang=js"
export * from "./PaginationPage.vue?vue&type=script&lang=js"

import "./PaginationPage.vue?vue&type=style&index=0&id=a1ed8fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ed8fca"]])

export default __exports__